<template>
  <alert-form
    :alert-id="alertId"
    :details="details"
    @submit="updateAlert"
    @close="$emit('close')"
  />
</template>

<script>
import AlertForm from '../Form.vue'

export default {
  name: 'EditAlert',
  components: { AlertForm },
}
</script>

<script>
import AlertForm from '../Form.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CreateAlert',
  components: { AlertForm },
  props: {
    details: {
      type: Boolean,
      default: true,
    },
    alertId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    updateAlert(alert) {
      const query = {
        alert: {
          name: alert.name,
          healthcheckId: alert.healthcheck.id,
          providers: alert.providers,
          message: alert.message,
        },
        id: this.alertId,
      }
      this.$store
        .dispatch('alerts/updateAlert', query)
        .then(() => {
          this.successToast('Alert was updated!')
          this.$emit('onRefresh')
        })
        .catch(error => {
          redirectError(error)
          this.errorToast(
            error.response?.data?.errors[0] ||
              'Something went wrong while updating alert!',
          )
        })
    },
  },
}
</script>
